import { createStore } from 'vuex'
import navigation from './navigation'

import products from '../config/products'

const defaultProduct = process?.env?.VUE_APP_PRODUCT || products.find(it => it.default).name

export default createStore({
	modules: {
		navigation
	},
	state () {
		return {
			debug: window.location.hostname === 'localhost',
			activeAnimations: [], // debug use only

			activeProduct: defaultProduct,
			activeModel: products.find(it => it.name === defaultProduct)?.model,
			productSelectorOpen: false,
			productConfig: products.find(it => it.name === defaultProduct)?.configuration,
			modelLoadingProgress: 0,
			hideControlPanel: false,

			explanationPaneOpen: false,
			explanationPaneContent: {},
			explanationPaneSub: null,
		}
	},
	mutations: {
		setActiveProduct(state, product) {
			state.activeProduct = product
		},
		setActiveModel(state, model) {
			state.activeModel = model
		},
		setActiveAnimations(state, animations) {
			state.activeAnimations = animations
		},
		setProductSelectorOpen(state, open) {
			state.productSelectorOpen = open
		},
		setProductConfig(state, value) {
			state.productConfig = value
		},
		setModelLoadingProgress(state, value) {
			state.modelLoadingProgress = value
		},
		setHideControlPanel(state, value) {
			state.hideControlPanel = value
		},
		setExplanationPaneOpen(state, open) {
			state.explanationPaneOpen = open
			if (!open) {
				state.explanationPaneSub = null
			}
		},
		setExplanationPaneContent(state, value) {
			state.explanationPaneContent = value
		},
		setExplanationPaneSub(state, value) {
			state.explanationPaneSub = value
		}
	},
	actions: {
		switchProduct({ commit }, name) {
			const productDefinition = products.find(it => it.name === name)
			commit('setActiveProduct', name)
      commit('setActiveModel', productDefinition?.model || "")
			commit('setProductConfig', productDefinition?.configuration || {})
		}
	}
})
